import * as angular from "angular";
import {IController, IQService, ITimeoutService} from "angular";
import * as _ from "lodash"
import * as $ from "jquery"
import {DataSet} from "vis-data";
import {ResourcesAlertsService} from "../../../resources/services/resources-alerts.service";
import {LeanPlanningService} from "../../services/lean-planning-service.service";
import {BringozTimelineService} from "../../../commons/services/bringoz-timeline-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class RoutesTimelineExtendedComponent implements IController {
  from: any;
  to: any;
  routes: any;
  serviceAreas: any;
  mapEnabled: any;
  tasksListType: any;
  selectedItemId: any;
  zoom: any;
  canEdit: any;
  queryString: any;
  usePurposeColor: any;
  selectedRouteIds: any;
  hiddenRouteIds: any;
  onTaskSelection: Function;
  onMovedItem: Function;
  onZoomChange: Function;
  onRecalcRoute: Function;
  onDeleteRoute: Function;
  onToggleSelectRoute: Function;
  onToggleRoute: Function;
  onToggleBlockRoute: Function;
  onRouteClick: Function;
  onAgentClick: Function;
  onRouteAction: Function;
  onViewServices: Function;

  private container: any;
  private vis: any;
  private options: any;
  private timeline: any;
  private topElementRef: any;
  private tableHeaderDivRef: any;
  private groupsDataSet: any;
  private itemsDataSet: any;
  private taskPurposeToColorMap: any;
  // private actionsByStatus: any;
  private routeActionToTitle: any;
  private SITE_WEIGHT_UNIT: any;
  private SITE_VOLUME_UNIT: any;
  private IS_PRICING_ENABLED: any;
  private headerNode: any;
  private movingItem: any;
  private serviceAreasMap: any;
  private groupRoutes: any; // TODO ask liron

  private $menuIcon: any;
  private $lockIcon: any;
  private $showIcon: any;


  ////////////////////////////////////// ICONS //////////////////////////////////////
  private iconsUrl: any;
  private $weightIcon: any;
  private $volumeIcon: any;
  private $packageIcon: any;

  // Single delegated click handler for all group-row actions, attached once on
  // `this.container` after the timeline is created. Replaces 6 per-cell
  // `addEventListener` calls inside `groupTemplate` / cell helpers. Per-group
  // context (e.g. `isBlockedByUser`) is re-fetched from `groupsDataSet` /
  // `this.routes` on click — fresher than the previous closure capture.
  private readonly _onContainerClick = (event: Event) => {
    const target = event.target as Element | null;
    if (!target) return;
    const actionEl = target.closest('[data-bz-action]') as HTMLElement | null;
    if (!actionEl) return;
    const action = actionEl.dataset.bzAction;
    const id = actionEl.dataset.bzId;
    if (!action || !id) return;

    // `route-action` did not originally wrap in `_onClicked()`; preserve the
    // synchronous shape. All other actions used the deferred pattern.
    if (action === 'route-action') {
      if (!this.canEdit) return;
      const routeRef = _.find(this.routes, (r: any) => r.id === id);
      this.onRouteAction({route: routeRef, event: event});
      return;
    }

    this._onClicked().then(() => {
      if (action === 'toggle-route') {
        const currentlyEnabled = !_.includes(this.hiddenRouteIds, id);
        this.onToggleRoute({id: id, isEnabled: !currentlyEnabled});
      } else if (action === 'select-route') {
        this.onToggleSelectRoute({id: id});
      } else if (action === 'block-route') {
        const group: any = this.groupsDataSet ? this.groupsDataSet.get(id) : null;
        if (group) {
          this.onToggleBlockRoute({id: id, isBlockedByUser: group.isBlockedByUser});
        }
      } else if (action === 'route-click') {
        this.onRouteClick({routeId: id});
      } else if (action === 'agent-click') {
        this.onAgentClick({agentId: id});
      }
    });
  };

  constructor(private $q: IQService, private confirmDialogService: ConfirmDialogService, private $filter, private $timeout: ITimeoutService,
              private tasksConstants, private commonsDialogService: CommonsDialogService, private $log, private splitService, private resourcesAlertsService: ResourcesAlertsService,
              private IAMPermissions, private leanPlanningConstants, private bringozTimelineService: BringozTimelineService, private commonsService: CommonsService,
              private moment, private leanPlanningService: LeanPlanningService) {

    this.vis = require('vis-timeline');
    this.taskPurposeToColorMap = tasksConstants.purposeToColor;
    this.routeActionToTitle = {
      handleUnpacked: 'Handle Unpacked Deliveries',
      assign: 'Assign And Select Driver',
      reOptimize: 'Re Optimize Route - Consider time windows',
      reOptimizeIgnore: 'Re Optimize Route - Ignore time windows',
      editRoute: false,
      resetRoute: 'Reset Route',
      removeRoute: 'Remove Route',
      removeTask: false,
      printRoute: 'Print'
    };
    this.SITE_WEIGHT_UNIT = $filter('translate')(splitService.getWeightUnit());
    this.SITE_VOLUME_UNIT = $filter('translate')(splitService.getVolumeUnit());
    this.IS_PRICING_ENABLED = IAMPermissions.hasPermission('priceplan.list');

    this.iconsUrl = {
      late: 'assets/images/icons/v2/info-outline.svg',
      relations: 'assets/images/icons/v2/relation.svg',
      address: 'assets/images/icons/v2/location-pin.svg',
      weight: 'assets/images/icons/v2/weight.svg',
      volume: 'assets/images/icons/v2/volume.svg',
      etaWindow: 'assets/images/icons/v2/timer.svg',
      timeWindow: 'assets/images/icons/v2/time-window.svg',
      relation: 'assets/images/icons/v2/relation.svg',
      eyeOn: 'assets/images/icons/v2/show.svg',
      eyeOff: 'assets/images/icons/v2/hide.svg',
      linkTo: 'assets/images/icons/v2/link-to.svg',
      package: 'assets/images/icons/v2/package.svg',
      account: 'assets/images/icons/v2/account.svg',
      lock: 'assets/images/icons/v2/lock.svg',
      menu: 'assets/images/icons/v2/menu.svg',
      agent: {
        Driver: 'assets/images/icons/agents/driver_flat.svg',
        ServiceAgent: 'assets/images/icons/agents/serviceagent_flat.svg'
      }
    }

    this.$weightIcon = document.createElement('IMG');
    this.$weightIcon.setAttribute("src", this.iconsUrl.weight);
    this.$weightIcon.classList.add('bringoz-icon-small', 'gray');

    this.$volumeIcon = document.createElement('IMG');
    this.$volumeIcon.setAttribute("src", this.iconsUrl.volume);
    this.$volumeIcon.classList.add('bringoz-icon-small', 'gray');

    this.$packageIcon = document.createElement('IMG');
    this.$packageIcon.setAttribute("src", this.iconsUrl.package);
    this.$packageIcon.classList.add('bringoz-icon-small', 'gray');

    this.headerNode = {
      route: document.createElement('span'),
      agent: document.createElement('span')
    };
    this.headerNode.route.textContent = $filter('translate')('Route');
    this.headerNode.agent.textContent = $filter('translate')('Driver');

    this.$menuIcon = document.createElement('IMG');
    this.$menuIcon.setAttribute("src", this.iconsUrl.menu);
    this.$menuIcon.classList.add('bringoz-icon', 'gray', "margin-left-5");

    this.$lockIcon = document.createElement('IMG');
    this.$lockIcon.setAttribute("src", this.iconsUrl.lock);
    this.$lockIcon.classList.add('icon', 'bringoz-icon');

    this.$showIcon = document.createElement('IMG');
    this.$showIcon.setAttribute("src", this.iconsUrl.eyeOn);
    this.$showIcon.classList.add('icon', 'bringoz-icon');

  }

  $onInit() {

    if (_.get(this.serviceAreas, 'length')) {
      this.serviceAreasMap = _.keyBy(this.serviceAreas, 'id');
    }

    // Check permissions to update roues
    if (_.isUndefined(this.canEdit)) {
      this.canEdit = this.IAMPermissions.hasPermission('planning.routes.update') ? this.canEdit : false;
    }

    // create visualization
    this.container = document.getElementById('timeline');

    // Set Timeline
    this.groupsDataSet = new DataSet()
    this.itemsDataSet = new DataSet()

    // Set Options
    this.options = {
      // option groupOrder can be a property name or a sort function
      // the sort function must compare two groups and return a value
      //     > 0 when a > b
      //     < 0 when a < b
      //       0 when a == b
      groupOrder: (a, b) => {
        return a.value - b.value;
      },
      groupOrderSwap: (groupDragged, groupToSwap, groups) => {
        const value = groupDragged.value;
        groupDragged.value = groupToSwap.value;
        groupToSwap.value = value;
      },
      groupTemplate: (group) => {

        if (!group) {
          return null;
        }

        const container = document.createElement('div');
        container.classList.add("table-container");

        let columns = [
          {key: 'route', values: [group.id, group.status]},
          {key: 'scheduling', values: [group.date, group.timeWindow]},
          {
            key: 'resource',
            values: [group.supplyResourceName, {
              agentId: group.agentId,
              agentName: group.agentName,
              requiredSkills: group.requiredSkills
            }]
          },
          {key: 'del', values: [group.del]},
          {key: 'cost', values: [group.cost]},
          {key: 'distance', values: [group.distance]},
          {key: 'alerts', values: [group.alerts]},
          {key: 'progress', values: [group.stats]},
          {
            key: 'capacity', values: [
              {v: group.weight, max: group.maxWeight, icon: this.$weightIcon, unit: this.SITE_WEIGHT_UNIT},
              {v: group.volume, max: group.maxVolume, icon: this.$volumeIcon, unit: this.SITE_VOLUME_UNIT},
              {v: group.packagesCount, max: group.maxPackagesCount, icon: this.$packageIcon}
            ]
          },
          {key: 'serviceAreas', values: group.serviceAreaIdList}
        ];

        if (!this.IS_PRICING_ENABLED) {
          columns = _.filter(columns, (c) => {
            return c.key !== 'cost';
          })
        }

        const actionsContainer = document.createElement('div');
        actionsContainer.classList.add("table-item", 'info-container');

        const actionsDiv = document.createElement('div');
        actionsDiv.classList.add("route-actions");
        actionsDiv.style.setProperty('background-color', group.color);

        const actionsButton = this.$menuIcon.cloneNode(true);
        actionsDiv.appendChild(actionsButton);

        const eyeButton = this._createEyeButton(group.id, !_.includes(this.hiddenRouteIds, group.id));

        const checkbox = this._createCheckboxButton(group.id, _.includes(this.selectedRouteIds, group.id));

        const iconsDiv = document.createElement('div');
        iconsDiv.classList.add("group-action-div");
        iconsDiv.appendChild(eyeButton);
        iconsDiv.appendChild(checkbox);

        if (this.leanPlanningService.getRoutesActionsMap([group]).block) {
          const blockButton = this._createBlockButton(group.id, group.isBlockedByUser);
          iconsDiv.appendChild(blockButton);
        }

        if (group.id) {
          actionsDiv.dataset.bzAction = 'route-action';
          actionsDiv.dataset.bzId = String(group.id);
        }

        actionsContainer.appendChild(actionsDiv);
        actionsContainer.appendChild(iconsDiv);
        container.insertAdjacentElement('beforeend', actionsContainer);

        _.forEach(columns, (c) => {
          const element = document.createElement('div');

          element.classList.add("table-item", "br-caption-2", c.key);

          _.forEach(c.values, (value, index: number) => {
            let valueElement;

            if (c.key === 'route') {
              valueElement = document.createElement('div');

              if (index === 0) {
                const routeIdSpan = document.createElement('a');
                routeIdSpan.classList.add("br-link-1", c.key);
                routeIdSpan.innerHTML = value;
                if (value) {
                  routeIdSpan.dataset.bzAction = 'route-click';
                  routeIdSpan.dataset.bzId = String(value);
                }
                valueElement.appendChild(routeIdSpan);
              } else {
                const statusDiv = document.createElement('div');
                const statusSpan = document.createElement('span');
                statusSpan.classList.add("br-caption-2");
                statusDiv.classList.add("route-status", c.key, value);
                statusSpan.textContent = this.$filter('translate')(value);
                statusDiv.appendChild(statusSpan);
                valueElement.appendChild(statusDiv);
              }
            }
              // else if(c.key === 'scheduling') {
              //   valueElement = document.createElement('div');
              //
              //   _.forEach(c.values, function(v, index) {
              //     if (index === 0) {
              //       var routeDate = document.createElement('span');
              //       routeDate.classList.add( "br-body-1", c.key);
              //       routeDate.innerHTML = value;
              //       valueElement.appendChild(routeDate);
              //     } else {
              //       var routeTimeWindow = document.createElement('a');
              //       routeTimeWindow.classList.add("br-body-1", c.key);
              //       routeTimeWindow.innerHTML = value;
              //       valueElement.appendChild(routeTimeWindow);
              //     }
              //   })
            // }
            else if (c.key === 'resource') {
              valueElement = document.createElement('div');

              if (index === 0) {
                const resourceName = document.createElement('span');
                resourceName.classList.add("br-body-1", c.key);
                resourceName.textContent = value;
                valueElement.appendChild(resourceName);
              } else {
                const skillsAndAgentRow = document.createElement('div');
                skillsAndAgentRow.classList.add('table-row');

                const skillsContainer = document.createElement('div');
                skillsContainer.classList.add("skill-tags-container", "margin-right-5");
                _.forEach(value.requiredSkills, (s, i) => {

                  const skill = document.createElement('div');
                  skill.classList.add("skill-tag", "skill-tag-margin");

                  const skillText = document.createElement('span')
                  skillText.classList.add("item-value", "br-body-1", "font-weight-400", c.key);
                  skillText.textContent = s;
                  skill.appendChild(skillText);
                  skillsContainer.appendChild(skill);
                })
                skillsAndAgentRow.appendChild(skillsContainer);

                if (value.agentId) {
                  const agentNameLink = document.createElement('a');
                  agentNameLink.classList.add("br-link-1", "text-ellipsis", c.key);
                  agentNameLink.innerHTML = value.agentName;
                  agentNameLink.dataset.bzAction = 'agent-click';
                  agentNameLink.dataset.bzId = String(value.agentId);
                  skillsAndAgentRow.appendChild(agentNameLink);
                } else {
                  const agentName = document.createElement('span');
                  agentName.classList.add("br-body-1", "text-ellipsis", c.key);
                  agentName.textContent = value.agentName || '';
                  skillsAndAgentRow.appendChild(agentName);
                }
                valueElement.appendChild(skillsAndAgentRow);
              }
            } else if (c.key === 'alerts') {
              valueElement = document.createElement('div');
              valueElement.classList.add("br-body-1", c.key);

              const warningCount = document.createElement('span');

              warningCount.textContent = value || '---';

              let tooltip;

              if (!!value) {
                warningCount.classList.add("warn");

                tooltip = document.createElement('div');
                tooltip.classList.add("table-tooltip");
                const tooltipContainer = document.createElement('div');
                tooltipContainer.classList.add("tooltip-container");

                const infoRow = document.createElement('div');
                infoRow.classList.add("info-row");
                const warningDetails = document.createElement('span');
                warningDetails.textContent = value > 1 ?
                  this.$filter('translate')('X_TASKS_LATE', {count: value}) :
                  this.$filter('translate')('TASK_LATE');
                infoRow.appendChild(warningDetails);
                tooltipContainer.appendChild(infoRow);

                tooltip.appendChild(tooltipContainer);

              }

              valueElement.appendChild(warningCount);

              if (!!value) {
                valueElement.appendChild(tooltip);
              }
            } else if (c.key === 'capacity') {
              valueElement = document.createElement('div');
              valueElement.appendChild(angular.copy(value.icon));

              if (value.max) {
                const progressBarElement = document.createElement('div');
                const progressBarFillElement = document.createElement('div');
                const percentageElement = document.createElement('span');
                const percentageValue = (value.v / value.max) * 100;
                const classByValue = percentageValue <= 30 ? 'low' : (percentageValue >= 90 ? 'high' : 'medium');

                progressBarElement.classList.add('progressbar');
                percentageElement.classList.add('margin-left-5');
                percentageElement.textContent = (percentageValue).toFixed(0) + '%';
                progressBarFillElement.style.width = (percentageValue > 100 ? 100 : percentageValue) + '%';
                progressBarFillElement.classList.add(classByValue);
                progressBarElement.appendChild(progressBarFillElement);
                valueElement.appendChild(progressBarElement);
                valueElement.appendChild(percentageElement);
              } else if (!!value.v) {
                const span = document.createElement('span');
                span.classList.add("item-value", "br-body-1", "font-weight-400", c.key);

                if (_.isNumber(value.max) && value.v > value.max) {
                  span.classList.add("warn");
                }

                valueElement.classList.add("item-value", c.key, "text-ellipsis");
                span.textContent = value.v + ' ' + (value.unit || '');
                valueElement.appendChild(span);
              } else {
                const spanNoValue = document.createElement('span');
                spanNoValue.textContent = '---';
                valueElement.appendChild(spanNoValue);
              }
            } else if (c.key === 'progress') {
              valueElement = document.createElement('div');
              const finished = (value.finished || 0);
              const progressBar = document.createElement('div');
              const progressBarFill = document.createElement('div');
              const percentage = document.createElement('span');
              progressBar.classList.add('progressbar');
              percentage.classList.add('margin-left-5');
              progressBarFill.style.width = finished + '%';
              percentage.textContent = ((finished * 100) / value.total).toFixed(0) + '%';
              progressBar.appendChild(progressBarFill);
              valueElement.appendChild(progressBar);
              valueElement.appendChild(percentage);
              // valueElement.innerHTML = value;
            } else if (c.key === 'serviceAreas') {

              if (index > 0) {
                return;
              }

              const serviceAreasText = !!c.values.length ?
                this.$filter('translate')('X_SERVICE_AREAS', c.values) :
                this.$filter('translate')('No Service Areas');

              valueElement = document.createElement('span');
              valueElement.classList.add("br-body-1", "font-weight-400");
              valueElement.textContent = serviceAreasText;
            } else {
              valueElement = document.createElement('span');
              valueElement.classList.add("br-body-1", "font-weight-400");
              valueElement.textContent = value;
            }

            if (valueElement) {
              valueElement.classList.add("item-value", c.key);
              element.insertAdjacentElement('beforeend', valueElement);
            }
          });
          container.insertAdjacentElement('beforeend', element);
        });

        return container;
      },
      onMoving: (item, callback) => {
        if (item.content != null) {
          callback(item); // updating the item
        } else {
          callback(null); // cancel updating the item
        }
      },
      onMove: (item, callback) => {
        const fromRouteId = item.routeId;
        const toRouteId = item.group;
        const serviceIds = item.serviceIds || [item.serviceId];
        const isBetweenRoutes = fromRouteId !== toRouteId;
        const routeFromRef = _.find(this.routes, ['id', item.routeId]);
        const routeToRef = isBetweenRoutes ? _.find(this.routes, ['id', item.group]) : undefined
        const isUnassigned = _.isEqual(_.get(routeToRef, 'status'), 'Unassigned');

        callback(item);
        // const canMove = isBetweenRoutes ? true : this._canItemMove(item, isBetweenRoutes, routeFromRef, routeToRef);
        const canMove = this._canItemMove(item, isBetweenRoutes, routeFromRef, routeToRef);

        if (!canMove) {
          callback(null);
          return;
        }

        if (!!routeToRef?.isBlockedByUser) {
          this.resourcesAlertsService.timelineRouteIsBlocked();
          callback(null);
          return;
        }

        const header = isBetweenRoutes ? 'Move service between routes' : 'Move service in route';
        const text = isBetweenRoutes ? 'Would you like to move this service to a another route?' : 'would you like to move this service in the route?';
        const actions = isBetweenRoutes ?
          this.commonsService.getConfirmActions(_.isEqual(_.get(routeToRef, 'status'), 'Unassigned') ? ['Reset Services'] : ['Assign service to the route associated agent']) :
          undefined

        this.confirmDialogService.confirmWithActions(header, text, actions)
          .then((payload) => {
            const groupsMap = this.timeline.components[3].groups;

            this.onMovedItem(
              {
                serviceIds: serviceIds,
                fromRouteId: fromRouteId,
                toRouteId: toRouteId,
                fromOrderedIds: _.chain(
                  groupsMap[fromRouteId].orderedItems.byStart)
                  .filter((item) => {
                    return !_.isEqual(item.data.type, 'background');
                  })
                  .map((filteredItem) => {
                    return filteredItem.data.taskId || filteredItem.data.taskIdList;
                  })
                  .flatten()
                  .value(),
                toOrderedIds: isBetweenRoutes ?
                  _.chain(
                    groupsMap[toRouteId].orderedItems.byStart)
                    .filter((item) => {
                      return !_.isEqual(item.data.type, 'background');
                    })
                    .map((filteredItem) => {
                      return filteredItem.data.taskId || filteredItem.data.taskIdList;
                    })
                    .flatten()
                    .value() : undefined,
                assignServices: !isBetweenRoutes ? undefined : (isUnassigned ? undefined : payload[0].enabled),
                resetServices: !isBetweenRoutes ? undefined : (isUnassigned ? payload[0].enabled : undefined)

              }
            );
            callback(null);
          })
          .catch(() => {
            callback(null);
          })
          .finally(() => {
            this.movingItem = undefined;
          })
      },
      onAdd: (data, callback) => {

        if (!data.items || !data.items.length) {
          callback(null);
          return;
        }

      },
      snap: (date, scale, step) => {
        var minute = 60 * 1000;
        return Math.round(date / minute) * minute;
      },
      orientation: 'top',
      editable: {
        add: this.canEdit,                             // add new items by double tapping
        updateTime: this.canEdit,               // drag items horizontally
        updateGroup: this.canEdit,              // drag items from one group to another
        remove: false,                          // delete an item by tapping the delete button top right
        overrideItems: false                    // allow these options to override item.editable
      },
      groupEditable: true,
      verticalScroll: true,
      zoomKey: 'ctrlKey',
      width: '100%',
      height: '100%',
      margin: {
        item: 5
      },
      stack: false,
      showTooltips: true,
      tooltip: {
        followMouse: true
      },
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      start: this.from ? this.moment(this.from).subtract(1, 'hour') : this.moment().startOf('day'),
      end: this.to ? this.moment(this.to).add(1, 'hour') : this.moment().endOf('day'),
      min: this.from ? this.moment(this.from).subtract(1, 'hour') : '',
      max: this.to ? this.moment(this.to).add(1, 'hour') : '',
      zoomMin: 1080000, // Zoom In Max 5 Mins
      // zoomMax: 18800000 // Zoom Out Max 1 Hour,
    };

    this.timeline = new this.vis.Timeline(this.container, [], this.options);

    // Single delegated click handler — replaces per-cell addEventListener calls
    // inside groupTemplate so listener count stays O(1) regardless of vis redraws.
    this.container.addEventListener('click', this._onContainerClick);

    // Set Table Header Element
    const topElementRef = this.timeline.body.dom.top;
    topElementRef.style = 'left: 0px';
    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("table-header-container");
    topElementRef.before(this.tableHeaderDivRef);

    let headers = [
      {key: 'info-container', value: ''},
      {key: 'route', value: 'Route'},
      {key: 'scheduling', value: 'Scheduling'},
      {key: 'resource', value: 'Resource'},
      {key: 'del', value: 'Del'},
      {key: 'cost', value: 'Cost'},
      {key: 'distance', value: 'Distance'},
      {key: 'alerts', value: 'Alerts'},
      {key: 'progress', value: 'Progress'},
      {key: 'capacity', value: 'Capacity'},
      {key: 'serviceAreas', value: 'Service Areas'}
    ];

    if (!this.IS_PRICING_ENABLED) {
      headers = _.filter(headers, (h) => {
        return h.key !== 'cost';
      })
    }

    _.forEach(headers, (h) => {
      const element = document.createElement('div');
      element.classList.add("table-header-item", "br-caption-2", (h.key || 'actions'));
      element.textContent = this.$filter('translate')(h.value);
      this.tableHeaderDivRef.appendChild(element);
    });

    // Init Groups/Items Data
    this._initTimelineEventListeners();

    // Set Timeline
    this.timeline.setGroups(this.groupsDataSet);
    this.timeline.setItems(this.itemsDataSet);

    if (_.get(this.routes, 'length')) {
      this._addRoutesToTimeline(this.routes);
      this._addRoutesTasksToTimeline(this.routes);
      this.onFit();
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {


    if (changes.routes && !changes.routes.isFirstChange() ||
      changes.tasksListType && !changes.tasksListType.isFirstChange()) {
      // groupsDataSet.clear();
      // itemsDataSet.clear();
      // _initTimelineData(ctrl.routes);

      const currentRoutes = changes.routes.currentValue || [];
      const previousRoutes = changes.routes.previousValue || [];

      const routesToRemove = _.differenceBy(previousRoutes, currentRoutes, 'id');
      const routesToAdd = _.differenceBy(currentRoutes, previousRoutes, 'id');


      const currentUpdatedRoutes = _.differenceBy(currentRoutes, routesToAdd, 'id');
      const previousUpdatedRoutes = _.differenceBy(previousRoutes, routesToRemove, 'id');

      const currentRoutesToUpdate = _.filter(currentUpdatedRoutes, (currentUpdatedRoute: any) => {
        const previousUpdatedRoute: any = _.find(previousUpdatedRoutes, ['id', currentUpdatedRoute.id]);
        // Check if route was changed
        return previousUpdatedRoute.updatedTime < currentUpdatedRoute.updatedTime;
      });

      const previousRoutesToUpdate = _.filter(previousUpdatedRoutes, (previousUpdatedRoute: any) => {
        const currentUpdatedRoute: any = _.find(currentUpdatedRoutes, ['id', previousUpdatedRoute.id]);
        // Check if route was changed
        return previousUpdatedRoute.updatedTime < currentUpdatedRoute.updatedTime;
      });

      // Remove groups and items
      const taskIdsToRemove = _.flatMap(_.concat(routesToRemove, previousRoutesToUpdate), 'taskIdListExt');
      const backgroundItemIdsToRemove = _.map(_.concat(routesToRemove, previousRoutesToUpdate), 'id');
      const routeIdsToRemove = _.map(_.concat(routesToRemove, previousRoutesToUpdate), 'id');

      if (_.get(routeIdsToRemove, 'length')) {
        this.groupsDataSet.remove(routeIdsToRemove);
      }
      if (_.get(taskIdsToRemove, 'length') || _.get(taskIdsToRemove, 'length')) {
        this.itemsDataSet.remove(_.concat(taskIdsToRemove, backgroundItemIdsToRemove));
      }

      this._addRoutesToTimeline(_.uniqBy(routesToAdd.concat(currentRoutesToUpdate), 'id'));
      this._addRoutesTasksToTimeline(_.uniqBy(routesToAdd.concat(currentRoutesToUpdate), 'id'));
      // _updateGroupsData(currentRoutes);

      if (!_.get(previousRoutes, 'length') && _.get(routesToAdd, 'length')) {
        this.onFit();
      }
    }

    if (changes.serviceAreas && !changes.serviceAreas.isFirstChange()) {
      this.serviceAreasMap = _.keyBy(this.serviceAreas || [], 'id');
    }

    if (changes.selectedItemId && !changes.selectedItemId.isFirstChange()) {
      const selectedTask = this._getTimelineTaskById(this.selectedItemId);
      if (selectedTask) {
        this.timeline.setSelection(selectedTask.id);
      }
    }

    if (changes.from && !changes.from.isFirstChange() ||
      changes.to && !changes.to.isFirstChange()) {

      this.options.min = this.moment(this.from).subtract(1, 'hour');
      this.options.max = this.moment(this.to).add(1, 'hour');
      this.timeline.setOptions(this.options);
    }

    if (changes.hiddenRouteIds && !changes.hiddenRouteIds.isFirstChange() ||
      changes.mapEnabled && !changes.mapEnabled.isFirstChange()) {
      const eyeButtons = document.getElementsByClassName("eye-button");
      _.forEach(eyeButtons, (b: any) => {
        const isEnabled = !_.includes(this.hiddenRouteIds, b.id);
        b.enabled = isEnabled;
        b.style.display = this.mapEnabled ? 'inherit' : 'none';
        b.style.opacity = isEnabled ? '1' : '0.5';
      });
    }

    if (changes.selectedRouteIds && !changes.selectedRouteIds.isFirstChange()) {
      const checkboxButtons = document.getElementsByClassName("group-checkbox");
      _.forEach(checkboxButtons, (b: any) => {
        b.checked = _.includes(this.selectedRouteIds, b.id);
      });
    }

    if (changes.zoom && !changes.zoom.isFirstChange()) {
      if (!_.isUndefined(this.zoom)) {
        this.zoom ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
        this.onZoomChange();
      }
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  public onFit() {
    this.$timeout(200).then(() => {
      this.timeline.fit();
      // ctrl.onFit();
    });
  }

  public onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }

  // ******************************
  //        Private methods
  // ******************************


  private _createEyeButton(id, isEnabled) {
    let eyeButton: any = document.createElement('IMG');
    eyeButton.setAttribute("src", this.iconsUrl.eyeOn);

    eyeButton.classList.add("bringoz-icon", "eye-button", "table-button");
    eyeButton.id = id;
    // @ts-ignore
    eyeButton.enabled = isEnabled;
    eyeButton.style.opacity = isEnabled ? '1' : '0.5';
    if (id) {
      eyeButton.dataset.bzAction = 'toggle-route';
      eyeButton.dataset.bzId = String(id);
    }
    return eyeButton;
  }

  private _addRoutesToTimeline(routes) {

    // Make sure the routes doesnt exist in timeline before adding them.
    const currentRouteIdsInTimeline = this.groupsDataSet.getIds();
    const routesToAdd = _.filter(routes, (route) => {
      return !_.includes(currentRouteIdsInTimeline, route.id);
    })

    const groups = this._mapRoutesToGroups(routesToAdd);
    this.groupsDataSet.add(groups);
  }

  private _addRoutesTasksToTimeline(routes) {
    let taskItems = [];
    let backgroundItems = [];

    // var activityItems = _getItemsData(tasks);
    _.forEach(routes, (r) => {
      taskItems = taskItems.concat(this._getItemsData(r, r.taskListExt));
    });
    _.forEach(routes, (r) => {
      backgroundItems = backgroundItems.concat(this._getRouteBackgroundItem(r));
      return this._getRouteBackgroundItem(r)
    });
    this.itemsDataSet.add(_.concat(_.flatten(taskItems), backgroundItems));
  }

  private _updateGroupsData(routes) {
    const updatedGroups = [];
    this.groupsDataSet.forEach((group) => {
      const routeRef = _.find(routes, (r) => {
        return group.id === _.get(r, 'planningResource.allocationId');
      })
      group.nestedGroups = _.map(this.groupRoutes, 'id');
      group.showNested = false;
      updatedGroups.push(group);
    });

    this.timeline.setGroups(updatedGroups);
  }


  private _mapRoutesToGroups(routes) {
    return _.map(routes, (route, index) => {
      return this._getGroupData(route, index);
    });
  }

  private _getGroupData(route, index) {
    const assignedCid = _.get(route, 'assignedCid');
    const isBlockedByUser = _.get(route, 'isBlockedByUser');
    return {
      id: route.rid,
      isBlockedByUser: isBlockedByUser,
      className: `group-row md-tiny ${isBlockedByUser ? 'blocked' : ''}`,
      value: index,
      color: route.color || 'black',
      status: route.status,
      date: this.$filter('bringozDate')(route.notBefore),
      timeWindow: this.$filter('timeWindow')({notBefore: route.notBefore, notAfter: route.notAfter}),
      agentId: assignedCid,
      agentName: assignedCid && route.agentReference ? this.$filter('userName')(route.agentReference) : undefined,
      requiredSkills: this._getTranslatedAgentSkills(_.get(route, 'requiredSkills', []), true),
      del: _.get(route, 'serviceIdList.length', 0),
      cost: this.$filter('bringozPrice')(route.courierPrice),
      distance: this.$filter('bringozDistance')(route.totalDistanceMeter),
      alerts: _.get(route, 'stats.notPacked', 0) + _.get(route, 'stats.late', 0),
      stats: _.get(route, 'stats', {}),
      maxLoad: _.get(route, 'maxLoad'),
      weight: this.$filter('bringozPaddingZeros')(_.get(route, 'maxLoad.weightLoad', 0), 2),
      maxWeight: _.get(route, 'maxLoad.weight'),
      volume: this.$filter('bringozPaddingZeros')(_.get(route, 'maxLoad.calculatedVolume', 0), 2),
      maxVolume: _.get(route, 'maxLoad.dimensions.cube'),
      packagesCount: _.get(route, 'maxLoad.numberOfItemsLoad', 0),
      maxPackagesCount: _.get(route, 'maxLoad.numberOfItems'),
      supplyResourceName: _.get(route, 'supplyResourceName', ''),
      // serviceAreaNames: _.map(_.get(route, 'serviceAreaIdList', []), function(areaId) { // Not Working (service areas map not always sets
      //   return ctrl.serviceAreasMap[areaId].areaName;
      // }),
      serviceAreaIdList: _.get(route, 'serviceAreaIdList', [])
    }
  }

  private _getItemsData(route, tasks) {
    const isEditableRoute = !route.isBlockedByUser && this.leanPlanningService.getRoutesActionsMap([route]).editRoute;
    const routeColor = route.color;

    // Guard for duplicate tasks on routes
    tasks = _.filter(tasks, (t) => {
      if (t.routeId !== route.id) {
        this.$log.error('Task planned on the wrong route - taskId: ' + t.id + ' task-routeId: ' + t.routeId + ' routeId: ' + route.id, t);
      }
      return t.routeId === route.id;
    })

    return _.map(tasks, (task, index) => {

      if (route.analysis[task.id]) {
        task.analysis = route.analysis[task.id];
      }

      const purpose = task.taskSpec.purpose;
      const isPoint = _.isEqual(task.taskType, 'Internal');
      const isBundle = _.isEqual(task.taskType, 'BundledStopover');
      const taskEta = this.leanPlanningService.getRouteTaskEta(route, task);
      const taskEtd = this.leanPlanningService.getRouteTaskEtd(route, task);
      const relations = _.get(task, 'relations', []);
      const taskPurpose = task.taskSpec.purpose;
      const itemColor = this.usePurposeColor ? this.taskPurposeToColorMap[purpose] : routeColor;
      const isLate = _.get(task, 'analysis.late', 0) > 0 && task.status !== 'CourierDeparted';
      const taskEtaWindow = this.$filter('timeWindow')({notBefore: taskEta, notAfter: taskEtd});

      return {
        id: task.id,
        // id: route.rid + task.id,
        start: this.moment(taskEta),
        end: this.moment(taskEtd),
        purpose: taskPurpose,
        status: task.status,
        bundleTasks: _.get(task, 'bundledTaskList', []), // For Bundle Only
        point: isPoint ? 'point' : 'box',
        serviceId: task.serviceId,
        serviceIds: task.bundleServiceIdList,
        group: route.rid,
        routeId: route.rid,
        taskId: task.id,
        className: isPoint ? 'internal' : (isBundle ? 'bundle' : 'task'),
        updatedAt: task.updatedAt,
        editable: {
          remove: false,
          updateGroup: isEditableRoute,
          updateTime: isEditableRoute
        },
        title: this.bringozTimelineService.getRouteTaskExtendedTimelineItemTooltip(task, taskEtaWindow, undefined),
        content: isPoint ?
          this.bringozTimelineService.getRouteInternalItemContent(task, true) :
          (isBundle ?
            this.bringozTimelineService.getRouteBundleTaskTimelineItemContent(task, relations, true) :
            this.bringozTimelineService.getRouteTaskTimelineItemContent(task, relations, true)),
        style: isPoint ? 
          'background-color: #7E7E7E !important; color: white;' :
          'background-color: ' + routeColor + '; color: white;',
      }
    });
  }

  private _initTimelineEventListeners() {

    const visLeft = document.getElementsByClassName('vis-left')[0] as any;
    const labelSetDiv = document.getElementsByClassName('vis-labelset')[0];
    const resizerWidth = parseInt($(visLeft).css('borderRightWidth'));
    let visLeftClientReact;
    let mouseDown = false;

    /////////////////////
    // Timeline Events //
    /////////////////////


    // On Item Click
    this.timeline.on('select', (properties) => {
      this._onTaskClicked().then(() => {
        const selectedTask = this._getTimelineTaskById(properties.items[0]);
        this.onTaskSelection({taskId: _.get(selectedTask, 'taskId')});
      });
    });

    // Mouse Down
    this.timeline.on('mouseDown', (props) => {
      visLeftClientReact = visLeft.getBoundingClientRect();
      const resizerFrom = visLeftClientReact.x + visLeftClientReact.width - resizerWidth;
      const resizerTo = visLeftClientReact.x + visLeftClientReact.width;

      if (props.event.pageX >= resizerFrom && props.event.pageX <= resizerTo) {
        mouseDown = true;
      }
    });

    // Mouse Move
    this.timeline.on('mouseMove', (props) => {
      if (mouseDown) {
        const px = (props.event.pageX - visLeftClientReact.x);
        visLeft.style.width = px + 'px';
        this.tableHeaderDivRef.style.width = (px - resizerWidth) + 'px';
        this.timeline.redraw();
      }
    });

    // Mouse Up
    this.timeline.on('mouseUp', (props) => {
      mouseDown = false;
    });

    // DoubleClick Event
    this.timeline.on('doubleClick', (properties) => {
      if (!properties.item) {
        return;
      }

      this._onTaskClicked().then(() => {
        const item = this.itemsDataSet.get(properties.item);
        this.onViewServices({ids: item.serviceIds || [item.serviceId]});
      });
      properties.event.preventDefault();
    });

    ///////////////////
    // Custom Events //
    ///////////////////

    // Sync Scroll - Table Header & Table Body
    labelSetDiv.addEventListener("scroll", (e) => {
      this.tableHeaderDivRef.scrollLeft = labelSetDiv.scrollLeft;
    }, {passive: true});
  }

  private _setGroupsHeader(routes) {
    if (!routes || !routes.length) {
      while (this.tableHeaderDivRef.firstChild) {
        this.tableHeaderDivRef.removeChild(this.tableHeaderDivRef.firstChild);
      }
    } else if (routes.length === 1) {
      this.topElementRef.style = 'left: 0px';
      this.tableHeaderDivRef.appendChild(this.headerNode.route);
      this.tableHeaderDivRef.appendChild(this.headerNode.agent);
      this.tableHeaderDivRef.classList.add("table-header-container");
    }
  }

  private _onTaskClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _getTimelineTaskById(id) {

    if (!id) {
      return undefined;
    }

    const selectedItem = this.itemsDataSet.get({
      filter: function (item) {
        return item.id === id || item.taskId === id;
      }
    });
    return this.itemsDataSet.get(selectedItem[0] ? selectedItem[0].id : undefined)
  }

  private _canItemMove(item, isBetweenRoutes, routeFromRef, routeToRef) {

    const canMoveFromRoute = this.leanPlanningService.getRoutesActionsMap([routeFromRef]).editRoute;
    const canMoveToRoute = isBetweenRoutes ? this.leanPlanningService.getRoutesActionsMap([routeToRef]).editRoute : true;

    if (!canMoveFromRoute || !canMoveToRoute) {
      return false;
    }

    if (!!isBetweenRoutes && !_.intersectionWith(routeFromRef.requiredSkills, routeToRef.requiredSkills, _.isEqual).length) {
      this.resourcesAlertsService.timelineNoMatchingSkillsInfo();
      return false;
    }

    const orderedItems = this.timeline.components[3].groups[item.group].orderedItems.byStart;
    const itemIndex = _.findIndex(orderedItems, (orderedItem: any) => {
      return orderedItem.data.taskId === item.taskId;
    });
    const pickupIndexes = _
      .chain(orderedItems)
      .map((orderedItem, index) => {
        return _.get(orderedItem, 'data.purpose') === 'Pickup' ? index : undefined;
      })
      .filter((pickupIndexes) => {
        return !_.isUndefined(pickupIndexes);
      })
      .value();

    return _.every(pickupIndexes, (currentValue) => {
      return currentValue < itemIndex;
    });
  }

  private _getTranslatedAgentSkills(skills, isFirstLetterOnly) {
    return _.map(skills, (s) => {
      return this._getTranslatedSkill(s, isFirstLetterOnly)
    });
  }

  private _getTranslatedSkill(skill, isFirstLetterOnly) {
    const text = this.$filter('translate')('SKILLS.' + skill);
    return isFirstLetterOnly ? text.charAt(0) : text;
  }


  private _setGroupVisibilityByQueryString(queryString) {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      group.visible = !queryString ||
        _.includes(group, queryString) ||
        _.includes(_.toLower(group.agentName), _.toLower(queryString)) ||
        _.includes(_.toLower(group.resourceName), _.toLower(queryString)) ||
        _.includes(_.toLower(group.id), _.toLower(queryString))
      updatedGroups.push(group);
    });
    this.groupsDataSet.update(updatedGroups);
    this.onFit();
  }

  private _getRouteBackgroundItem(route) {
    return {
      id: route.rid,
      start: this.moment(route.notBefore),
      end: this.moment(route.notAfter),
      group: route.rid,
      type: 'background',
      style: 'background-color: ' + route.color,
      className: 'background'
    }
  }

  private _createBlockButton(id, isBlockedByUser) {
    const blockButton: any = document.createElement('IMG');
    blockButton.setAttribute("src", this.iconsUrl.lock);

    blockButton.id = id;
    blockButton.classList.add("bringoz-icon", "block-button", "table-button");
    blockButton.isBlockedByUser = isBlockedByUser;
    blockButton.style.opacity = isBlockedByUser ? '1' : '0.5';
    if (id) {
      blockButton.dataset.bzAction = 'block-route';
      blockButton.dataset.bzId = String(id);
    }
    return blockButton;
  }

  private _createCheckboxButton(id, isEnabled) {
    const checkbox: any = document.createElement("INPUT");
    checkbox.setAttribute("type", "checkbox");
    checkbox.classList.add("group-checkbox", "margin-5");
    checkbox.id = id;
    checkbox.checked = isEnabled;
    if (id) {
      checkbox.dataset.bzAction = 'select-route';
      checkbox.dataset.bzId = String(id);
    }
    return checkbox;
  }

  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  $onDestroy() {
    if (this.container) {
      this.container.removeEventListener('click', this._onContainerClick);
      this.container = null;
    }
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }


}

angular
  .module('bringoz.admin.lean-planning')
  .component('routesTimelineExtended', {
      bindings: {
        from: '<',
        to: '<',
        routes: '<',
        serviceAreas: '<',
        mapEnabled: '<?',
        tasksListType: '<?',
        selectedItemId: '<',
        zoom: '<',
        canEdit: '<',
        queryString: '<?',
        usePurposeColor: '<?',
        selectedRouteIds: '<?',
        hiddenRouteIds: '<?',
        onTaskSelection: '&',
        onMovedItem: '&',
        onZoomChange: '&',
        onRecalcRoute: '&',
        onDeleteRoute: '&',
        onToggleSelectRoute: '&',
        onToggleRoute: '&',
        onToggleBlockRoute: '&',
        onRouteClick: '&',
        onAgentClick: '&',
        onRouteAction: '&',
        onViewServices: '&'
      },
      template: require('./routes-timeline-extended.html').default,
      controller: RoutesTimelineExtendedComponent
    }
  );
